import type { Group } from "three";
import { createSyntheticStackUnit } from "./factories/synthetic-stack-unit.ts";
import {
  createFirstYardPurchaseBoxProxy,
  createFirstYardWorkSphereProxy,
} from "./factories/trigger-proxies/index.ts";

export type FarmAssetFactory = () => Group;
export type FarmAssetFactoryRegistry = Readonly<Record<string, FarmAssetFactory>>;

export const FARM_ASSET_FACTORIES: FarmAssetFactoryRegistry = Object.freeze({
  "first-yard-purchase-box-proxy": createFirstYardPurchaseBoxProxy,
  "first-yard-work-sphere-proxy": createFirstYardWorkSphereProxy,
  "synthetic-stack-unit": createSyntheticStackUnit,
});

// D-017 admits exact, project-owned geometry carriers for the first-yard runtime.
export const FARM_ASSET_MANIFEST_DIGESTS: Readonly<Record<string, string>> = Object.freeze({
  "first-yard-purchase-box-proxy": "d1b57ca67e4d51e37f28526f7deec1bfb1248f65163fc97cd62f41977fdccefc",
  "first-yard-work-sphere-proxy": "973937477413c5a47a7aa404f48c9c84c5cba309942acc980a8c0c4bf455a4d7",
  "synthetic-stack-unit": "f0bb70993a5ec2aefadbb741de4c1beb88509abb4bd4a096403586ef0942ad80",
});
